import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Label for the Movement indicator',
    defaultMessage: 'Customs Content Type',
    id: 'jVRoBG',
  },
  placeholder: {
    description: 'Placeholder for Movement indicator',
    defaultMessage: 'Select one...',
    id: '2FAGPk',
  },
});
